import type { Card, FormValues, FormInstance } from '../types';
import { evaluateConditions } from './conditions';

/**
 * Checks if a card should be considered completed based on its considerCompletedIf condition
 */
export function isCardConsideredCompleted(
  card: Card,
  values: FormValues | Record<string, unknown>
): boolean {
  if (card.considerCompletedIf) {
    return evaluateConditions(card.considerCompletedIf, values);
  }
  return false;
}

/**
 * Gets completed instances for a card
 */
export function getCardInstances(
  card: Card,
  completedForms: Record<string, FormInstance[]>
): FormInstance[] {
  return completedForms[card.groupKey] || [];
}

/**
 * Checks if a card has completed instances or should be considered completed
 */
export function hasCardCompletedInstances(
  card: Card,
  completedForms: Record<string, FormInstance[]>,
  values: FormValues | Record<string, unknown>
): boolean {
  // Check if card should be considered completed based on configuration
  if (isCardConsideredCompleted(card, values)) {
    return true; // Card is not required, so consider it completed
  }

  const completedInstances = getCardInstances(card, completedForms);
  return completedInstances.length > 0;
}

/**
 * Filters cards based on showIf conditions
 */
export function getVisibleCards(
  cards: Card[],
  values: FormValues | Record<string, unknown>
): Card[] {
  return cards.filter((card) => evaluateConditions(card.showIf, values));
}
